module.exports = __webpack_public_path__ + "static/media/blank_copy.0d5869e7.pdf";